import { LoggedIn } from './LoggedIn';
import { LoggedOut } from './LoggedOut';
export { Loading } from './Base';

export const Route = {
  LoggedIn,
  LoggedOut,
};
